import { makeApiCall } from "../../../../client/src/utils/api/apiUtils.js"

const getExchangeRate = async (data, operation, prevData) => {
    const { targetField } = operation
    const currency = data['currency']

    if (!currency) return data

    //console.log('RUNNING GET EXCHANGE RATE:', data)

    // A new currency always needs its own rate. The rate it replaces says
    // nothing about it: a DKK form holds 1, and applying an EUR document kept
    // that 1 — EUR booked at par (seen 2026-10-09).
    const currencyChanged = currency !== prevData['currency']

    if (data['date'] !== prevData['date'] || prevData['exchangeRate'] === undefined || currencyChanged) {
        //console.log('The DATE has changed')
        if (data['exchangeRate'] !== 1 || currencyChanged) {
            //console.log('The Exchange Rate must be fetched')

            // Format the date to YYYY-MM-DD
            let formattedDate = data['date']
            if (formattedDate && formattedDate.includes('T')) {
                // If the date is in ISO format (e.g., "2025-04-10T10:00:00.000Z")
                // Extract just the date part (YYYY-MM-DD)
                formattedDate = formattedDate.split('T')[0]
            }



            try {
                //console.log(`Fetching exchange rate for date: ${formattedDate}, currency: ${currency}`)
                // Make the API call with the formatted date
                const response = await makeApiCall(`fxRate/${formattedDate}/${currency}`)
                //console.log('Exchange rate response:', response)

                // Update the data with the exchange rate from the response
                if (response && !response.error) {
                    data = {
                        ...data,
                        [targetField]: response.exchangeRate || data[targetField]
                    }
                }
            } catch (error) {
                console.error('Error fetching exchange rate:', error)
            }
        }
    }

    return data
}

export default getExchangeRate
